var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotate = function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5h-9C.675 16.5 0 15.825 0 15V6c0-.825.675-1.5 1.5-1.5S3 5.175 3 6v7.5h7.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5Z",
    fill: "#125A40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.015 33.015c-6.18 0-11.985-3.855-14.16-10.02-.27-.78.135-1.635.915-1.92.78-.27 1.635.135 1.92.915 2.205 6.24 9.06 9.525 15.3 7.335 3.03-1.065 5.445-3.24 6.84-6.135a11.93 11.93 0 0 0 .495-9.165c-1.065-3.03-3.24-5.445-6.135-6.84a11.93 11.93 0 0 0-9.165-.495c-1.695.6-3.24 1.575-4.5 2.835l-6.99 6.57c-.6.57-1.545.54-2.115-.06-.57-.6-.54-1.56.06-2.115l6.96-6.54a14.913 14.913 0 0 1 5.58-3.495c3.78-1.335 7.845-1.11 11.46.615 3.615 1.725 6.33 4.77 7.665 8.55 2.745 7.8-1.365 16.38-9.165 19.125-1.635.57-3.315.84-4.965.84Z",
    fill: "#125A40"
  })));
};
export default SvgRotate;